<template>
  <div id="printm">
    <div class="common-page  mt20 printhide">
      <!-- <div class="common-page common-head-end">
                <i class="icon-tr-sign-out"></i>
      </div>-->
    </div>
    <!-- <div class="search-form ml20 flex printhide">
      <div class="block flex ml20 mt20">
        <el-date-picker
          v-model="value1"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </div>
      <div class="ml10 mt20">
        <el-button type="primary" @click="searchSubmit" size="small"
          >查询</el-button
        >
      </div>
    </div> -->
    <div class="f-list flex">
      <div class="flex1 flex tx-center" style="flex-wrap: wrap">
        <div id="tab2" class="tab1"></div>
        <div id="tab3" class="tab1"></div>
        <div id="tab4" class="tab1"></div>
      </div>
    </div>

    <!-- <div class="center mt20 printhide" style="margin-bottom:20px">
             <el-button type="primary" v-print="'#printm'">打印报表</el-button>

    </div> -->
  </div>
</template>
<script>
import echarts from "echarts";
import { getTime } from "../../api/common.js";
export default {
  data() {
    return {
      power: 0,
      value1: [], // 时间查询
      params: {
        starttime: "",
        endtime: "",
      },
      // oneData:[],
      fourData: [], //巡查整改情况
      twoData: [], // 巡查点位数量
      threeData: [], //巡查人员次数
    };
  },
  created() {
    // let time = data.sysTime2.replace(/-/g, "/");
    let time = new Date(+new Date() + 8 * 3600 * 1000)
      .toJSON()
      .substr(0, 19)
      .replace("T", " ")
      .replace(/-/g, "/");

    let timeLine = new Date(time).getTime();
    this.params.starttime = new Date(timeLine).Format("yyyy-MM-01 00:00:00");
    this.params.endtime = new Date(timeLine).Format("yyyy-MM-dd hh:mm:ss");

    this.getList();
  },
  mounted() {},
  //     watch:{
  //     cpNum(){
  //          this.getList()
  //     }
  // },
  methods: {
    getList() {
      this.getWater();
    },
    searchSubmit() {
      // function changeArr(val) {
      //   var arr = val.split(" ");
      //   var n = arr[0].replace(/['年','月']/g, "-");
      //   n = n.replace(/日/g, "");
      //   return n;
      // }
      this.clear();
      this.params.starttime = this.value1[0];
      this.params.endtime = this.value1[1];
      // console.log(this.params)
      // return
      //  console.log(this.params)
      this.getList();
    },
    clear() {
      (this.fourData = []), //巡查整改情况
        (this.twoData = []), // 巡查点位数量
        (this.threeData = []); //巡查人员次数
    },

    async getWater() {
      function setData(res, data) {
        res.map((item) => {
          data.push({ name: item.name, value: item.data });
        });
      }

      //巡查区域
      // await this.$post("/patrol/selectarea").then((data) => {
      //   data.data.map((item) => {
      //     areaList.push(item.x_company_area);
      //   });
      // });
      //巡查人员
      // await this.$post('/patrol/xcpersonlist')

      var personli = [];
      await this.$post("/user/jjmap", this.params).then((res) => {
        if (res) {
          //处理巡查占比数据

          //处理巡查点分布数据
          // setData(res.data[0].four, this.fourData);

          setData(res.data[0].one, this.twoData);

          //处理巡查整改情况
          setData(res.data[0].two, this.threeData);

          setData(res.data[0].three, this.fourData);
          return;
        }
        // 巡查点占比
      });

      this.makeChart(this.threeData, "tab3", "行业类型单位比例");
      this.makeLine(this.twoData, "tab2", {
        title: "接警数量月统计",
        hname: "月份",
        sname: "数量",
        insername: "数量",
      });
      this.makeLine(this.fourData, "tab4", {
        title: "接警数量地区统计",
        hname: "地区",
        sname: "数量",
        insername: "地区数量",
      });
    },

    makeLine(arr1, id, config) {
      var arr2 = [];
      arr1.map((item) => {
        arr2.push(item.name);
      });
      var option = {
        title: {
          text: config.title,
          left: "center",
          top: "370px",
        },
        tooltip: {
          trigger: "axis",
        },
        xAxis: {
          data: arr2,
          name: config.hname,
          nameTextStyle: {
            fontSize: 14,
            fontFamily: "Arial",
            fontWeight: "bold",
          },
        },
        yAxis: {
          splitLine: {
            show: false,
          },
          splitArea: {
            show: false,
          },
          name: config.sname,
          nameTextStyle: {
            fontSize: 14,
            fontFamily: "Arial",
            fontWeight: "bold",
          },
          //  max: 10000,
          // scale: false,
          // splitNumber: 10,
          // minInterval: 0
        },
        dataZoom: [
          {
            start: 2,
            type: "inside",
          },
          {
            type: "slider",
            start: 2,
          },
        ],
        series: {
          name: config.insername,
          type: "bar",
          data: arr1,
          // label: {
          //   show: true,
          //   position: "top",
          //   fontSize: 18,

          //   color: "#000",
          // },
          large: true,
        },
      };
      echarts.init(document.getElementById(id)).setOption(option);
    },
    //饼图
    makeChart(arr, id, title) {
      // console.log(this.chartList)
      var arr2 = [];
      if (arr.length == 0) {
        arr.push({ value: 0, name: "暂无数据" });
      }
      arr = arr.filter((item) => {
        if (item.value > 0) {
          arr2.push(item);
        }
        return item.value > 0;
      });

      let option = {
        title: {
          text: title,
          left: "center",
          top: "370px",
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          left: "100px",
          data: arr2,
        },
        series: [
          {
            name: "",
            title: "访问来源",
            show: true,
            type: "pie",
            //            label: {
            //   show: true,
            //    position: 'top',
            //    fontSize: 18,

            //    color:'#000'
            // },
            radius: "70%",
            center: ["50%", "50%"],
            data: arr,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      echarts.init(document.getElementById(id)).setOption(option);
    },
  },
};
</script>
<style scoped lang="scss">
.tab1 {
  width: 100%;
  min-height: 400px;
  margin: 20px 80px 20px 30px;
}

#line {
  height: 250px;
  width: 100%;
}

@media print {
  #tab1,
  #tab2,
  #tab3,
  #tab4 {
    margin-top: 120px;
    width: 100%;
  }
  .printhide {
    display: none;
  }
  #printm {
  }
}
</style>
